import script from "./CheckBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckBadge.vue?vue&type=script&setup=true&lang=ts"

import "./CheckBadge.vue?vue&type=style&index=0&id=1d295b34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d295b34"]])

export default __exports__